import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ORDERS_FEATURE_KEY, State, OrdersAdapter } from './order.reducer';
import { calculateOrderFields } from '@care-portals/shared';

// Lookup the 'Orders' feature state managed by NgRx
export const selectState = createFeatureSelector<State>(ORDERS_FEATURE_KEY);

const { selectAll, selectIds, selectEntities } = OrdersAdapter.getSelectors();

export const getLoadingOrders = createSelector(
  selectState,
  (state: State) => state.loadingOrders
);

export const selectOrders = createSelector(selectState, selectAll);

export const selectOrdersIds = createSelector(selectState, selectIds);
export const getOrdersEntities = createSelector(selectState, selectEntities);

export const getActiveOrderIndex = createSelector(selectState, (state: State) =>
  state.ids.findIndex(id => id === state.selectedId?.toString())
);

export const getMinMaxIds = createSelector(selectOrdersIds, ids => {
  const numIds = ids.map(i => Number(i));
  return {
    min: numIds ? Math.min(...numIds) : undefined,
    max: numIds ? Math.max(...numIds) : undefined
  };
});

export const getOrdersFilter = createSelector(
  selectState,
  (state: State) => state.filters
);

export const getOrdersCount = createSelector(
  selectState,
  (state: State) => state.ordersCount
);

export const hasMore = createSelector(
  selectState,
  (state: State) => state.hasMore
);

export const getSavingOrder = createSelector(
  selectState,
  (state: State) => state.savingOrder
);

export const getSavingOrderId = createSelector(
  selectState,
  (state: State) => state.savingOrderId
);

export const getLoading = createSelector(
  selectState,
  (state: State) => state.loading
);

export const getExportingOrders = createSelector(
  selectState,
  (state: State) => state.exportingOrders
);

export const getOrderResult = createSelector(
  selectState,
  (state: State) => state.orderResult
);

export const getSelectedId = createSelector(
  selectState,
  (state: State) => state.selectedId
);

export const getActiveOrder = createSelector(
  getOrdersEntities,
  getSelectedId,
  (entites, selectedId) => {
    const order = selectedId ? entites[selectedId] : null;
    return calculateOrderFields(order);
  }
);

export const getActiveOrderPrescriptionsResults = createSelector(
  getActiveOrder,
  activeOrder => {
    return activeOrder?.rxResults;
  }
);
export const getErrors = createSelector(
  selectState,
  (state: State) => state.error
);
